/**
 *
 * ListFilters
 *
 */

/* eslint-disable react/jsx-curly-brace-presence */

import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    // margin: `0 ${theme.spacing(4)} 0`,
    '& label': {
      marginLeft: 'unset',
      marginRight: theme.spacing(4),
      // marginLeft: theme.spacing(4)
    },
  },
  stgInput: {
    padding: `${theme.spacing(4)} 0 0 0`,
    marginTop: '2rem',
    marginLeft: '-15px',
    '& >input': {
      border: '1px solid #ccc',
      borderRadius: '3px',
      padding: '10px',
    },
    '&:before': {
      content: 'unset',
    },
    '&:after': {
      content: 'unset',
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing(4)} 0`,
    transform: 'translate(0, 24px) scale(1)',
  },
  stgCheckBoxRight: {
    width: 'auto',
  },
  mandatory: {
    color: theme.status.errorColor,
  },
})

const CheckboxWithLabel = (
  checked,
  classes,
  label,
  value,
  isMandatory,
  isError,
  errorMessage,
  labelPosition,
  fullWidth,
  helperText,
  ...rest
) => (
  <FormControl fullWidth={fullWidth} className={classes.margin} error={isError}>
    {label && labelPosition === 'top' ? (
      <InputLabel htmlFor={label} className={classes.stgLabel}>
        {label} {''}
        {isMandatory && <span className={classes.mandatory}>*</span>}
      </InputLabel>
    ) : (
      ''
    )}
    {labelPosition === 'top' && <Checkbox checked={checked} value={value} className={classes.stgInput} {...rest} />}
    {labelPosition === 'right' && (
      <FormControlLabel
        control={<Checkbox checked={checked} value={value} {...rest} className={classes.stgCheckBoxRight} />}
        label={label}
      />
    )}
    {helperText && <FormHelperText id="chkbx-error-text">{isError && errorMessage}</FormHelperText>}
  </FormControl>
)

CheckboxWithLabel.defaultProps = {
  isMandatory: false,
  isError: false,
  errorMessage: 'Invalid value',
  labelPosition: 'top',
  fullWidth: true,
  helperText: true,
}

export default withStyles(styles)(CheckboxWithLabel)
